/**
 * Check if a survey question should be visible in the
 * form, depending on the atreemo logic.
 *
 * @param {object} question
 * @param {object} formData
 *
 * @returns {boolean}
 */
export const questionShouldShow = (question, formData = {}) => {
    const defaultVisibility = question.rules
        ?.type;

    // If there are no rules, always show the question
    if (defaultVisibility === undefined) {
        return true;
    }

    let ruleMatched = false;

    if (question.rules.or) {
        // Check if at least one of the OR rules match
        ruleMatched = question.rules
            .or
            .some(({ question_id, values }) => values.includes(formData[question_id]));

        if (question.rules.type === 'Hide' && ruleMatched) {
            return false;
        }

        if (question.rules.type === 'Hide' && !ruleMatched) {
            return true;
        }

        if (question.rules.type === 'Show' && ruleMatched) {
            return true;
        }

        if (question.rules.type === 'Show' && !ruleMatched) {
            return false;
        }
    }

    if (question.rules.and) {
        // Check if all of the AND rules match
        ruleMatched = question.rules
            .and
            .every(({ question_id, values }) => values.includes(formData[question_id]));

        if (question.rules.type === 'Hide' && ruleMatched) {
            return false;
        }

        if (question.rules.type === 'Hide' && !ruleMatched) {
            return true;
        }

        if (question.rules.type === 'Show' && ruleMatched) {
            return true;
        }

        if (question.rules.type === 'Show' && !ruleMatched) {
            return false;
        }
    }

    return false;
};
